
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"20.539"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 705","transform":"translate(-38 -298)"}},[_c('path',{attrs:{"data-name":"Path 1159","d":"M52.317 302.213A7.546 7.546 0 0038 305.519a7.439 7.439 0 00.72 3.214l-.707 3.535a.645.645 0 00.757.759l3.578-.707a7.414 7.414 0 001.492.522 8.818 8.818 0 018.477-10.629z","fill":"#42ddb3"}}),_c('path',{attrs:{"data-name":"Path 1160","d":"M59.281 314.233a7.5 7.5 0 00.323-.8h-.024a7.528 7.528 0 00-6.77-9.928 7.519 7.519 0 10-.361 15.03 7.438 7.438 0 003.2-.72c3.919.775 3.613.72 3.7.72a.645.645 0 00.632-.771z","fill":"#7368d8"}}),_c('rect',{attrs:{"data-name":"Rectangle 2145","width":"7","height":"2","rx":"1","transform":"translate(49 308)","fill":"#4a4291"}}),_c('rect',{attrs:{"data-name":"Rectangle 2146","width":"7","height":"2","rx":"1","transform":"translate(48 311)","fill":"#4a4291"}})])])
          )
        }
      }
    